import { takeLatest } from "redux-saga/effects";
import {
  GET_AMENITIES,
  GET_BUILDING_AMENITIES_V2,
  EDIT_AMENITIES,
  ADD_AMENITIES,
  ADD_AMENITIES_V2,
  UPDATE_AMENITY_V2,
  UPLOAD_AMENITY_WAIVER_DOC,
  UPLOAD_AMENITY_IMAGES_BATCH_V2,
  SYNC_AMENITY_IMAGES_V2,
  GET_AMENITY,
  GET_AMENITY_V2,
  REMOVE_AMENITY,
  GET_AMENITY_TYPES
} from "../constants";
import apiCall from "../../utils/apiCall";

const getAmenity = apiCall({
  type: GET_AMENITY,
  method: "GET",
  path: ({ id }) => `/amenities/${id}`
});

const getAmenityV2 = apiCall({
  type: GET_AMENITY_V2,
  method: "get",
  path: ({ id }) => `/v2/amenities/${id}`
});

const getAmenities = apiCall({
  type: GET_AMENITIES,
  method: "get",
  path: ({ id }) => `/buildings/${id}/amenities`
});

const getBuildingAmenitiesV2 = apiCall({
  type: GET_BUILDING_AMENITIES_V2,
  method: "get",
  path: ({ id }) => `/buildings/${id}/v2/amenities`
});

const addAmenities = apiCall({
  type: ADD_AMENITIES,
  method: "post",
  path: "/amenities"
});

const addAmenitiesV2 = apiCall({
  type: ADD_AMENITIES_V2,
  method: "post",
  path: "/v2/amenities"
});

const updateAmenityV2 = apiCall({
  type: UPDATE_AMENITY_V2,
  method: "put",
  path: ({ id }) => `/v2/amenities/${id}`
});

const uploadAmenityWaiverDoc = apiCall({
  type: UPLOAD_AMENITY_WAIVER_DOC,
  method: "post",
  path: "/docs",
  isFile: true
});

const uploadAmenityImagesBatchV2 = apiCall({
  type: UPLOAD_AMENITY_IMAGES_BATCH_V2,
  method: "post",
  path: "/images/batch",
  isFile: true
});

const syncAmenityImagesV2 = apiCall({
  type: SYNC_AMENITY_IMAGES_V2,
  method: "put",
  path: "/images/sync",
  isFile: true
});

const editAmenities = apiCall({
  type: EDIT_AMENITIES,
  method: "put",
  path: ({ id }) => `/amenities/${id}`
});

const removeAmenity = apiCall({
  type: REMOVE_AMENITY,
  method: "delete",
  path: ({ id }) => `/amenities/${id}`
});
const getAmenityTypes = apiCall({
  type: GET_AMENITY_TYPES,
  method: "get",
  path: (payload) => {
    const orgId = payload?.orgId;
    return orgId
      ? `/metadata?name=amenity-types&org=${orgId}`
      : "/metadata?name=amenity-types";
  }
});
export default function* amenitiesSaga() {
  yield takeLatest(REMOVE_AMENITY, removeAmenity);
  yield takeLatest(GET_AMENITIES, getAmenities);
  yield takeLatest(GET_BUILDING_AMENITIES_V2, getBuildingAmenitiesV2);
  yield takeLatest(ADD_AMENITIES, addAmenities);
  yield takeLatest(ADD_AMENITIES_V2, addAmenitiesV2);
  yield takeLatest(UPDATE_AMENITY_V2, updateAmenityV2);
  yield takeLatest(UPLOAD_AMENITY_WAIVER_DOC, uploadAmenityWaiverDoc);
  yield takeLatest(UPLOAD_AMENITY_IMAGES_BATCH_V2, uploadAmenityImagesBatchV2);
  yield takeLatest(SYNC_AMENITY_IMAGES_V2, syncAmenityImagesV2);
  yield takeLatest(EDIT_AMENITIES, editAmenities);
  yield takeLatest(GET_AMENITY, getAmenity);
  yield takeLatest(GET_AMENITY_V2, getAmenityV2);
  yield takeLatest(GET_AMENITY_TYPES, getAmenityTypes);
}
